<template>
  <div class="page-container">
    <div class="query-title">客户查询与修改</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出全部" @click="exportPage" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            :show-overflow="true"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #flag_dgd="{row}">
              <el-checkbox v-model="row.flag_dgd" disabled size="mini" true-label="X" false-label="" />
            </template>
            <template #cooperation="{row}">
              <el-checkbox v-model="row.cooperation" disabled size="mini" true-label="X" false-label="" />
            </template>
            <template #zzfld000026="{row}">
              <el-checkbox v-model="row.zzfld000026" disabled size="mini" true-label="X" false-label="" />
            </template>
            <template #block="{row}">
              <el-checkbox v-model="row.block" disabled size="mini" true-label="X" false-label="" />
            </template>
            <template #zzfld00009n="{row}">
              <el-checkbox v-model="row.zzfld00009n" disabled size="mini" true-label="X" false-label="" />
            </template>
            <template #is_sp="{row}">
              <el-checkbox v-model="row.is_sp" disabled size="mini" true-label="X" false-label="" />
            </template>
            <template #ygdjzwkpkh="{row}">
              <el-checkbox v-model="row.ygdjzwkpkh" disabled size="mini" true-label="X" false-label="" />
            </template>
            <template #partner="{row}">
              <el-link type="primary" @click="toDetail(row.partner)">{{ row.partner }}</el-link>
            </template>
            <template #zmd_empower="{row}">
              <el-checkbox v-model="row.zmd_empower" disabled size="mini" true-label="X" false-label="" />
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getClientList } from '@/api/sap/client-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/clientQuery'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { formatSapDate } from '@/mixins/index'

export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async exportPage() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getClientList)
      data.map(item => {
        item.datum = formatSapDate(item.datum)
        item.zzfld00003d = formatSapDate(item.zzfld00003d)
      })
      frontExport(this.gridOptions.columns, data, '地址信息报表')
    },
    toDetail(code) {
      this.$router.push({
        path: '/wly/master-data-client/client-edit',
        query: {
          code
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await getClientList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/client-manage/clientQuery.vue